import Typography from 'transfix-ui/core/Typography'
import { withStyles } from 'transfix-ui/core/styles'

export const DialogHeader = withStyles(theme => ({
  root: {
    fontFamily: theme.typography.fontFamily,
    fontStyle: 'normal',
    fontWeight: theme.typography.fontWeightRegular,
    fontSize: 20,
    // There's a bug with using theme.spacing() with line height
    lineHeight: '27px',
  },
}))(Typography)
